export * from './zh/p1'



// WEBPACK FOOTER //
// ./src/common/lang/zh.js